import React from "react";

export default function GlobalFilter({ filter, setFilter, placeholders }) {
  return (
    <div className="d-flex justify-content-end align-items-center">
      <span>Search</span>
      <input
        placeholder={placeholders}
        className="form-control"
        style={{
          margin: "8px",
          height: "1.2rem",
          width: "20rem",
          borderRadius: "10px",
        }}
        type="text"
        value={filter || ""}
        onInput={(e) => {
          let value = e.target.value;
          if (value != "") {
            setFilter(value);
          } else {
            setFilter("");
          }
        }}
      />
    </div>
  );
}
